import { object, string } from 'yup'

import { i18nErrorCodes }           from '../form-utils'
import { emailSchema, phoneSchema } from './formatSchemas'

const { required } = i18nErrorCodes

export default object().shape({
  email:    emailSchema.required(required),
  name:     string().required(required),
  position: string().required(required),
  company:  string().required(required),
  sector:   string().required(required),
  phone:    phoneSchema,
  mobile:   phoneSchema.required(required),
})

export const emptyContact = {
  email:    '',
  name:     '',
  position: '',
  company:  '',
  sector:   '',
  phone:    '',
  mobile:   '',
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/contact.schema.ts